export const steps = {
  SEARCH: 0,
  PAY: 1,
  DATA: 2,
};
